/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AppointmentsListAliases {
  APPOINTMENTS_FETCH = 'appointments-fetch',
  AUTOCOMPLETE_CATEGORIES = 'autocomplete-categories',
  BUTTON_ADD_APPOINTMENT = 'button-add-appointment',
  CARD_APPOINTMENTS_0 = 'card-appointments-0',
  CARD_APPOINTMENTS_WAITING_LIST = 'card-appointments-waiting-list',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_FILTER_FIELD = 'date-filter-field',
  DECK_APPOINTMENTS = 'deck-appointments',
  DECK_WAITING_LIST = 'deck-waiting-list',
  FETCH_WAITING_LIST = 'fetch-waiting-list',
  FIELD_FILTER_CATEGORIES = 'field-filter-categories',
  FILTER_APPOINTMENTS_LIST = 'filter-appointments-list',
  FRAGMENT_REFERENCE_ANALYTICS = 'fragment-reference-analytics',
  FROM_DATE_FIELD = 'from-date-field',
  LAYOUT_0 = 'layout-0',
  LAYOUT_APPOINTMENTS = 'layout-appointments',
  LAYOUT_CONTENT = 'layout-content',
  MAPPER_CATEGORIES = 'mapper-categories',
  MAPPER_WAITING_LIST = 'mapper-waiting-list',
  PANEL_DECK_APPOINTMENTS = 'panel-deck-appointments',
  PANEL_DECK_ITEMS = 'panel-deck-items',
  PANEL_DECK_WAITING_LIST = 'panel-deck-waiting-list',
  PANEL_GENERAL = 'panel-general',
  TEXT_TYPE = 'text-type',
}
export { AppointmentsListAliases };
